import {
	postCandEdu,
	postCandExp,
	getParticularForm,
	postProjectsInfo,
	postCandAchieve,
	postCandAward,
	postCandEvent,
	postCandAchieveFileUpload,
	putCandEdu,
	postCandInfo,
	getParticularFormData,
	putCandExp,
	putProjectEdit,
	putCandAchieve,
	putCandAward,
	putCandEvent,
	getSkillSuggestions,
	updateCandidateOnboard,
} from "@/utils/apiFunctions";
import ProfilePictureUpload from "@/components/InputComponents/ProfilePictureUpload.vue";
import InputField from "@/components/InputComponents/Input.vue";
import DateField from "@/components/InputComponents/DateField.vue";
import PhoneNumber from "@/components/InputComponents/PhoneNumber.vue";
import MultiSelectCustom from "@/components/InputComponents/MultiSelectCustom.vue";
import Textarea from "@/components/InputComponents/Textarea.vue";
import SelectCustom from "@/components/InputComponents/SelectCustom.vue";
import FormTags from "@/components/InputComponents/FormTags.vue";
import UploadDocument from "@/components/InputComponents/UploadDocument.vue";

import { mapGetters } from "vuex";
import {
	dynamicRules,
	columnWidth,
	showError,
	validateField,
	getPersonalInfoCol,
} from "@/utils/customField";
import LocationSearch from "@/components/LocationSearch.vue";
import Checkbox from "@/components/InputComponents/Checkbox.vue";
import toast from "@/components/mixin/toast.js";
import Selectwithsearch from "@/components/selectwithsearch.vue";
import MultipleInput from "@/components/InputComponents/MultipleInput.vue";
import Loader from "@/components/fixedcomponents/Loader.vue";
import DiscardModal from "@/components/BuilderPage/DiscardModal.vue";
import FormShimmer from "@/components/FormShimmer.vue";
import EventBus from "@/utils/EventBus";
import store from "@/store";
import { trackFormSubmitted, trackHomePageLoaded, trackResumeCreated } from "@/utils/posthogHelpers";
export default {
	name: "FormModal",
	data() {
		return {
			suggestions: [],
			suggestionsTimer: null,
			skillWindowStart: 0,
			skillWindowEnd: 0,
			skillNextPage: null,
			skillPrevPage: null,
			skillPageSize: 30,
			skillLoading: false,
			skillScrollDir: null,
			skillSearchText: "",
			skillSuggestionRequestId: 0,
			loopvar: 5,
			tabIndex: 0,
			loading: false,
			isLaptop: true,
			isTablet: false,
			disableButton: false,
			saveAndAddNew: false,
			changesDetected: false,
			isImageChanged: false,
			showDispTooltip: false,
			showTooltip: false,
			discardModal: false,
			formShimmer: true,
			selectedTab: "rewardField",
			formID: this.$route.query.formID || this.form?.formID,
			basicArray: [],
			advanceArray: [],
			touchedFields: [],
			customFieldsArray: [],
			valText: {},
			newObject: {},
			validations: {},
			formDetails: {},
			originalData: {},
			getUpdateImage: false,
			isImageRemoved: false,
			openRemoveReplace: false,
			uploadbtnClick: false,
			invalidPhoneFields: {},
		};
	},
	mixins: [toast],
	async created() {
		let type = "add";
		if (
			(this.formID == "personalDetails" &&
				this.candidateInfo?.database_demographics) ||
			this.$route.query.id ||
			this.formType == "edit" ||
			this.formType == "editParser"
		) {
			type = "edit";
		}
		this.initializeData(type);
	},
	mounted() {
		this.checkScreenSize(); // Check screen size initially

		window.addEventListener("resize", this.checkScreenSize);
		EventBus.$on("open-replace-remove", this.toggleRemoveReplace);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.checkScreenSize);
		EventBus.$off("open-replace-remove");
	},
	computed: {
		...mapGetters("candidateVUEX", {
			candidateInfo: "getcandidateInfo",
			candProgress: "getCandProgressResp",
			getPrimaryCandidateInfo: "getPrimaryCandidateInfo",
		}),
		...mapGetters("userVUEX", {
			resumeClinic: "getResumeClinic",
		}),
		checkFirstName() {
			const { firstName, middleName, lastName } = this.newObject;
			const firstLen = firstName ? firstName.length : 0;
			const middleLen = middleName ? middleName.length : 0;
			const lastLen = lastName ? lastName.length : 0;
			let total = firstLen + middleLen + lastLen;
			total = middleLen > 0 ? total + 2 : total + 1;
			if (total <= 38) {
				let displayName = firstName;
				if (middleName) {
					displayName += " " + middleName;
				}
				displayName += " " + lastName;
				return displayName;
			} else {
				if (middleName) {
					total = firstLen + 3 + lastLen;
					if (total <= 38) {
						return firstName + " " + middleName[0] + " " + lastName;
					} else {
						total = firstLen + 1 + middleLen + 1 + 1;
						if (total <= 38) {
							return firstName + " " + middleName + " " + lastName[0];
						}
						total = firstLen + 4;
						if (total <= 38) {
							return firstName + " " + middleName[0] + " " + lastName[0];
						} else {
							return firstName;
						}
					}
				} else {
					total = firstLen + lastLen + 1;
					if (total <= 38) {
						return firstName + " " + lastName;
					} else {
						total = firstLen + 2;
						if (total <= 38) {
							return firstName + " " + lastName[0];
						} else {
							return firstName;
						}
					}
				}
			}
		},
		disableAward() {
			if (
				this.formType == "edit" &&
				!this.newObject.parser &&
				this.tabIndex != 0
			) {
				return true;
			}
			return false;
		},
		disableCerti() {
			if (
				this.formType == "edit" &&
				!this.newObject.parser &&
				this.tabIndex != 1
			) {
				return true;
			}
			return false;
		},
		disableEvent() {
			if (
				this.formType == "edit" &&
				!this.newObject.parser &&
				this.tabIndex != 2
			) {
				return true;
			}
			return false;
		},
	},

	components: {
		ProfilePictureUpload,
		InputField,
		DateField,
		PhoneNumber,
		MultiSelectCustom,
		Textarea,
		SelectCustom,
		LocationSearch,
		Checkbox,
		Selectwithsearch,
		MultipleInput,
		FormTags,
		UploadDocument,
		Loader,
		DiscardModal,
		FormShimmer,
	},
	props: {
		showModal: Boolean,
		form: Object,
		singleData: Object,
		formType: String,
		selectedAchieveTab: String,
		isDocumentUpload: Boolean,
		fromOnboarding: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		singleData(newVal) {
			if (this.formType == "edit" || newVal || this.formType == "editParser") {
				this.newObject = newVal;
				if (this.formID == "project") {
					this.newObject.skillsUsed = newVal.skillsUsed;
					if (!newVal.currentProject) {
						this.newObject.currentProject = false;
					}
				}
			}
		},
		// newObject: {
		// 	deep: true,
		// 	handler(newValue) {
		// 		this.checkForChanges(newValue);
		// 	},
		// },
	},
	methods: {
		validateBeforeLeave() {
			this.checkForChanges();
			if (this.changesDetected) {
				return true;
			} else {
				return false;
			}
		},
		updateCheckUpload(val) {
			this.uploadbtnClick = val;
		},
		toggleRemoveReplace() {
			this.openRemoveReplace = true;
		},
		replacePhoto() {
			EventBus.$emit("replace-photo");
			this.openRemoveReplace = false;
		},
		deletePhoto() {
			EventBus.$emit("delete-photo");
			this.openRemoveReplace = false;
		},
		setUpdateValue(val) {
			this.getUpdateImage = val;
		},
		setRemovedImg(val) {
			this.isImageRemoved = val;
		},
		speechRec() {
			this.$emit("speech-rec");
		},
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
			this.isTablet = window.innerWidth >= 600 && window.innerWidth < 1024;
		},
		onModalHidden(event) {
			this.checkForChanges();
			if (this.changesDetected) {
				this.discardModal = true;
				this.$emit("discard-modal");
				event.preventDefault();
			} else {
				this.$emit("close-modal");
			}
		},
		checkForChanges() {
			const newData = {
				data: { ...this.newObject },
			};
			const changed = !this.deepEqual(newData.data, this.originalData.data);
			if (changed) {
				this.changesDetected = true;
			} else {
				this.changesDetected = false;
			}
		},
		deepEqual(obj1, obj2) {
			const omitPortfolio = (obj) => {
				const { portfolio, ...rest } = obj;
				return rest;
			};

			const filteredObj1 = omitPortfolio(obj1);
			const filteredObj2 = omitPortfolio(obj2);

			console.log("the obj", filteredObj1, filteredObj2);

			return JSON.stringify(filteredObj1) === JSON.stringify(filteredObj2);
		},
		openModal() {
			this.openFormModal = true;
		},
		notAMultipleInput(field) {
			return (
				(field.key != "highlight" && this.formID == "experience") ||
				(field.key != "responsibility" && this.formID == "project") ||
				(field.key != "portfolio" && this.formID == "personalDetails")
			);
		},
		selectTab(tab) {
			this.formShimmer = true;
			this.selectedTab = tab;
			this.newObject.achieveType =
				this.selectedTab == "rewardField"
					? "award"
					: this.selectedTab == "certificateField"
					? "certificate"
					: "event";
			this.$emit("select-parser-tab", this.newObject.achieveType);
			setTimeout(() => {
				this.initializeData("add");
			}, 100);
		},
		async initializeData(type) {
			this.loader = true;
			this.customFields = [];
			this.basicArray = [];
			this.advanceArray = [];
			this.newObject = {};
			try {
				const customFields = await this.getStaticCustomFields(
					this.formID,
					type
				);

				if (customFields.length) {
					if (type == "add") {
						[this.customFieldsArray, this.newObject, this.touchedFields] =
							customFields;
						this.originalData = {
							data: { ...this.newObject },
						};
					} else {
						[this.customFieldsArray, this.touchedFields] = customFields;
					}

					// Iterate through the original array and push objects into respective arrays based on category value
					this.customFieldsArray.forEach((obj) => {
						if (obj.category === 1 || obj.category === null) {
							this.basicArray.push(obj); // Push objects with category value 1 into category1Array
						} else if (obj.category === 2) {
							this.advanceArray.push(obj); // Push objects with category value 2 into category2Array
						}
					});

					this.validations = dynamicRules(this.customFieldsArray);
					this.$forceUpdate();
				}
			} catch (error) {
				this.$emit("close");
			} finally {
				this.loader = false;

				// ONLY for personalDetails: if the form schema API returned empty
				// (getParticularForm cold-cache / brief network blip), retry once
				// before proceeding. All other formIDs are unaffected by this block.
				if (this.formID === "personalDetails" && this.basicArray.length === 0) {
					try {
						const retryFields = await this.getStaticCustomFields(
							this.formID,
							type
						);
						if (retryFields && retryFields.length) {
							if (type === "add") {
								[this.customFieldsArray, this.newObject, this.touchedFields] =
									retryFields;
								this.originalData = { data: { ...this.newObject } };
							} else {
								[this.customFieldsArray, this.touchedFields] = retryFields;
							}
							this.customFieldsArray.forEach((obj) => {
								if (obj.category === 1 || obj.category === null) {
									this.basicArray.push(obj);
								} else if (obj.category === 2) {
									this.advanceArray.push(obj);
								}
							});
							this.validations = dynamicRules(this.customFieldsArray);
							this.$forceUpdate();
						}
					} catch (retryErr) {
						// Retry also failed — emit close so the modal doesn't sit blank.
						this.formShimmer = false;
						this.$emit("close");
						return;
					}
				}

				if (this.formID == "personalDetails") {
					// Always try the API first — this handles both existing users AND
					// users who just uploaded a resume (whose parsed data is in the DB
					// but whose Vuex state may not have updated yet due to timing).
					try {
						const res = await getParticularFormData(this.formID);
						if (res.status == 200 && res.data?.data) {
							this.newObject = res.data.data;
							if (
								!this.newObject.dateOfBirth ||
								this.newObject.dateOfBirth === ""
							) {
								this.touchedFields["dateOfBirth"] = true;
								this.$forceUpdate();
							}
							this.originalData = {
								data: { ...this.newObject },
							};
						} else {
							// API responded but returned no usable data — fall back to
							// pre-filling from registration info (truly new user, no DB record yet)
							this.newObject.firstName = this.candidateInfo?.firstName || "";
							this.newObject.lastName = this.candidateInfo?.lastName || "";
							this.newObject.email = this.candidateInfo?.email || "";
							this.newObject.phoneNumber =
								this.candidateInfo?.phoneNumber || "";
							if (this.candidateInfo?.altMobileNumber) {
								this.newObject.altPhoneNumber =
									this.candidateInfo?.altMobileNumber || "";
							}
							this.originalData = {
								data: { ...this.newObject },
							};
						}
					} catch (err) {
						// API failed entirely (no DB record exists) — fall back gracefully
						this.newObject.firstName = this.candidateInfo?.firstName || "";
						this.newObject.lastName = this.candidateInfo?.lastName || "";
						this.newObject.email = this.candidateInfo?.email || "";
						this.newObject.phoneNumber = this.candidateInfo?.phoneNumber || "";
						if (this.candidateInfo?.altMobileNumber) {
							this.newObject.altPhoneNumber =
								this.candidateInfo?.altMobileNumber || "";
						}
						this.originalData = {
							data: { ...this.newObject },
						};
					}
				} else if (
					this.singleData &&
					(this.formType == "edit" || this.formType == "editParser")
				) {
					this.newObject = this.singleData;
					this.originalData = {
						data: { ...this.newObject },
					};
					if (this.formID == "achievement") {
						if (this.newObject.parser) {
							this.newObject.achieveType = this.selectedAchieveTab;
						}
						this.selectedTab =
							this.newObject.achieveType == "award"
								? "rewardField"
								: this.newObject.achieveType == "certificate"
								? "certificateField"
								: "eventField";
						if (this.newObject.achieveType == "award") {
							this.tabIndex = 0;
						} else if (this.newObject.achieveType == "certificate") {
							this.tabIndex = 1;
						} else if (this.newObject.achieveType == "event") {
							this.tabIndex = 2;
						} else {
							this.tabIndex = 0;
						}
					}
				}
				setTimeout(() => {
					this.formShimmer = false;
				}, 500);
			}
		},

		async _fetchSkillPage(searchText, page) {
			try {
				const resp = await getSkillSuggestions({
					search: searchText || "",
					page,
				});
				if (resp?.status === 200 && resp.data?.data?.response) {
					const d = resp.data.data;
					return {
						items: d.response.map((item) => item.text).filter(Boolean),
						next_page: d.next_page ?? null,
						prev_page: d.prev_page ?? null,
					};
				}
				return null;
			} catch {
				return null;
			}
		},
		async fetchSkillSuggestions(searchText) {
			if (this.skillLoading) return;
			this.skillSuggestionRequestId += 1;
			const requestId = this.skillSuggestionRequestId;
			this.skillLoading = true;
			this.skillScrollDir = null;
			this.suggestions = [];
			try {
				const p0 = await this._fetchSkillPage(searchText, 0);
				if (requestId !== this.skillSuggestionRequestId) return;
				this.suggestions = p0?.items ?? [];
				this.skillWindowStart = 0;
				this.skillWindowEnd = 0;
				this.skillPrevPage = p0?.prev_page ?? null;
				this.skillNextPage = p0?.next_page ?? null;
				this.skillSearchText = searchText || "";
			} finally {
				if (requestId === this.skillSuggestionRequestId)
					this.skillLoading = false;
			}
		},
		async loadNextSkillPage() {
			if (this.skillLoading || this.skillNextPage === null) return;
			this.skillLoading = true;
			this.skillScrollDir = "down";
			try {
				const result = await this._fetchSkillPage(
					this.skillSearchText,
					this.skillWindowEnd + 1
				);
				if (!result) return;
				const combined = [...this.suggestions, ...result.items];
				const maxItems = this.skillPageSize * 3;
				if (combined.length > maxItems) {
					this.suggestions = combined.slice(combined.length - maxItems);
					this.skillWindowStart += 1;
				} else {
					this.suggestions = combined;
				}
				this.skillWindowEnd += 1;
				this.skillNextPage = result.next_page;
				this.skillPrevPage =
					this.skillWindowStart > 0 ? this.skillWindowStart - 1 : null;
			} finally {
				this.skillLoading = false;
				this.skillScrollDir = null;
			}
		},
		async loadPrevSkillPage() {
			if (this.skillLoading || this.skillWindowStart === 0) return;
			this.skillLoading = true;
			this.skillScrollDir = "up";
			try {
				const result = await this._fetchSkillPage(
					this.skillSearchText,
					this.skillWindowStart - 1
				);
				if (!result) return;
				const combined = [...result.items, ...this.suggestions];
				const maxItems = this.skillPageSize * 3;
				if (combined.length > maxItems) {
					this.suggestions = combined.slice(0, maxItems);
					this.skillWindowEnd -= 1;
				} else {
					this.suggestions = combined;
				}
				this.skillWindowStart -= 1;
				this.skillPrevPage = result.prev_page;
				this.skillNextPage = result.next_page;
			} finally {
				this.skillLoading = false;
				this.skillScrollDir = null;
			}
		},
		handleSkillFocus(field) {
			if (this.suggestionsTimer) clearTimeout(this.suggestionsTimer);
			this.fetchSkillSuggestions("");
		},
		handleSkillTyping(field, searchText) {
			if (this.suggestionsTimer) clearTimeout(this.suggestionsTimer);
			this.suggestionsTimer = setTimeout(() => {
				this.fetchSkillSuggestions(searchText?.trim() || "");
			}, 250);
		},

		async getStaticCustomFields(formID, type) {
			try {
				if (this.formID == "achievement" && this.selectedAchieveTab) {
					this.selectedTab =
						this.selectedAchieveTab == "award"
							? "rewardField"
							: this.selectedAchieveTab == "certificate"
							? "certificateField"
							: "eventField";
				}

				let response = await getParticularForm(formID);
				if (response.status === 200) {
					this.formDetails = response.data.data.data;
					const fields =
						this.formID != "achievement"
							? this.formDetails.fields
							: this.formDetails[this.selectedTab];

					const object = {
						customFields: {},
					};
					const touchedFields = {};
					fields.forEach((field) => {
						if (field.fieldType == "default") {
							field.controlType == "multi_select" ||
							field.controlType === "multi_text"
								? (object[field.key] = [])
								: field.controlType === "boolean"
								? (object[field.key] = false)
								: (object[field.key] = "");
							touchedFields[field.key] = false;
						} else {
							field.controlType == "multi_select" ||
							field.controlType === "multi_text"
								? (object["customFields"][field.key] = [])
								: field.controlType === "boolean"
								? (object["customFields"][field.key] = false)
								: (object["customFields"][field.key] = "");
							touchedFields[field.key] = false;
						}
					});

					if (type == "edit") {
						return [fields, touchedFields];
					}

					return [fields, object, touchedFields];
				}
			} catch (error) {
				throw new Error(error);
			}
		},

		getColumn(field) {
			if (
				field.key == "profileSummary" ||
				field.key == "portfolio" ||
				field.key == "summary" ||
				field.key == "highlight" ||
				field.key == "responsibility" ||
				field.key == "description" ||
				field.controlType == "boolean" ||
				(this.formID == "achievement" &&
					!this.isLaptop &&
					field.key == "uploadFile") ||
				field.key == "image"
			) {
				return 12;
			} else if (
				(field.key == "uploadFile" && this.formID == "achievement") ||
				this.isTablet
			) {
				return 6;
			} else {
				return columnWidth(field.controlType, !this.isLaptop && !this.isTablet);
			}
		},
		getPersonalInfoCol(field) {
			return getPersonalInfoCol(field, this.isMobile);
		},
		getError(field) {
			return showError(field, this.touchedFields[field.key], this);
		},

		getVmodel(field) {
			if (field.key == "portfolio") {
				return this.newObject["portfolioLink"];
			}
			return field.fieldType == "default"
				? this.newObject[field.key]
				: this.newObject.customFields[field.key];
		},
		isYYYMMDDFormat(dateStr) {
			// Regular expression to check if the date is in yyyy-mm-dd format
			const regex = /^\d{4}-\d{2}-\d{2}$/;
			return regex.test(dateStr);
		},
		convertDate(date) {
			const [year, month, day] = date.split("-");
			return `${day}-${month}-${year}`;
		},
		getCountryCode(field) {
			return field.key == "phoneNumber"
				? this.newObject["countryCode"]
				: this.newObject["altCountryCode"];
		},
		updateCountryCode(field, value) {
			if (field.key == "phoneNumber") {
				this.$set(this.newObject, "countryCode", value);
			} else {
				this.$set(this.newObject, "altCountryCode", value);
			}
			this.$forceUpdate();
			validateField(field, this);
		},
		updatePhoneValidation(field, isInvalid) {
			if (!this.invalidPhoneFields) {
				this.$set(this, "invalidPhoneFields", {});
			}
			this.$set(this.invalidPhoneFields, field.key, isInvalid);
			validateField(field, this);
			this.$forceUpdate();
		},
		filteredOptions(array1, array2) {
			console.log("array1", array1, "array2", array2);

			// Filter array1 by checking if no object in array2 matches the condition
			return array1.filter((data1) => {
				// Use .some() to check if any object in array2 matches the key in data1 (case-insensitive)
				return !array2.some(
					(data2) => data2.skillName?.toLowerCase() === data1.key?.toLowerCase()
				);
			});
		},
		updateFieldValue(field, value) {
			if (field.fieldType === "default") {
				this.$set(this.newObject, field.key, value);
				// this.newObject[field.key] = value;
			} else {
				this.$set(this.newObject.customFields, field.key, value);
			}

			if (field.key == "currentEducation") {
				const isYearOfPassoutMandatory = value ? false : true;
				// Update both validations and mandatory properties in a single loop
				this.validations["yearOfPassout"].required = isYearOfPassoutMandatory;

				this.basicArray.forEach((data) => {
					if (data.key === "yearOfPassout") {
						data.mandatory = isYearOfPassoutMandatory;
					}
				});
			}

			if (
				(field.key == "currentExperience") |
				(field.key == "currentProject")
			) {
				const isEndDateMandatory = value ? false : true;
				// Update both validations and mandatory properties in a single loop
				this.validations["endDate"].required = isEndDateMandatory;

				this.basicArray.forEach((data) => {
					if (data.key === "endDate") {
						data.mandatory = isEndDateMandatory;
					}
				});
				this.newObject["endDate"] = "";
			}

			if (field.key == "qualification") {
				if (value == "10th" || value == "12th") {
					this.validations["degree"].required = false;
					this.basicArray.forEach((data) => {
						if (data.key === "degree") {
							data.mandatory = false;
						}
					});
				} else {
					this.validations["degree"].required = true;
					this.basicArray.forEach((data) => {
						if (data.key === "degree") {
							data.mandatory = true;
						}
					});
				}
			}

			if (field.key == "experienceLevel") {
				console.log(value);

				const isEndDateMandatory =
					value == "intermediate" || value == "senior" ? true : false;
				// Update both validations and mandatory properties in a single loop
				this.validations["totalYearsOfExp"].required = isEndDateMandatory;

				this.basicArray.forEach((data) => {
					if (data.key === "totalYearsOfExp") {
						data.mandatory = isEndDateMandatory;
					}
				});
			}

			if (field.key == "qualification") {
				const isFieldOfStudyMandatory = !(value === "10th" || value === "12th");
				this.basicArray.forEach((data) => {
					if (data.key === "degree") {
						data.mandatory = isFieldOfStudyMandatory;
					}
				});
			}

			this.touchedFields[field.key] = true;

			validateField(field, this);
			this.$forceUpdate();
		},
		disableDateField(field) {
			if (field.key == "endDate") {
				return !field.mandatory;
			}
			return false;
		},
		handleInput(field) {
			this.touchedFields[field.key] = true;
			this.$forceUpdate();
		},
		handleBlur(field) {
			if (this.touchedFields[field.key] && !this.validations[field.key]) {
				validateField(field, this);
				this.$forceUpdate();
			}
		},
		validateField(field) {
			return validateField(field, this);
		},
		validateForm() {
			let invalidForm = false;

			if (this.formID == "achievement") {
				this.newObject.achieveType =
					this.selectedTab == "rewardField"
						? "award"
						: this.selectedTab == "certificateField"
						? "certificate"
						: "event";
			}
			if (this.customFieldsArray && this.customFieldsArray.length > 0) {
				for (let i = 0; i < this.customFieldsArray.length; i++) {
					const field = this.customFieldsArray[i];
					this.touchedFields[field.key] = true;
					this.$forceUpdate();
					if (!validateField(field, this)) {
						invalidForm = true;
					}
				}
			}
			if (!invalidForm) {
				let funcName = this.newObject.parser
					? "add" + this.formID.charAt(0).toUpperCase() + this.formID.slice(1)
					: this.formType
					? this.formType +
					  this.formID.charAt(0).toUpperCase() +
					  this.formID.slice(1)
					: "add" + this.formID.charAt(0).toUpperCase() + this.formID.slice(1);

				if (funcName == "editPersonalDetails") {
					funcName = "addPersonalDetails";
				}
				// console.log("DEBUG: validateForm", {
				// 	funcName,
				// 	formID: this.formID,
				// 	formType: this.formType,
				// 	hasFunc: typeof this[funcName] === "function"
				// });
				this[funcName]();
				this.loading = true;
			} else {
				this.errorModal("Error", "Please fill mandatory details");
			}
		},

		createPortfolioObjects(portfolioLinks) {
			// Define the portfolio websites and their names
			const platforms = {
				linkedin: "linkedIn",
				dribbble: "dribbble",
				behance: "behance",
				gitlab: "gitlab",
				github: "github",
			};

			// Use a Set to track unique portfolio links
			const seenLinks = new Set();
			const portfolioObjects = [];

			// Iterate through the portfolioLink array
			portfolioLinks.forEach((link) => {
				if (typeof link === "string" && link.trim() !== "") {
					const trimmedLink = link.trim();
					if (seenLinks.has(trimmedLink)) return; // Skip if link already processed

					seenLinks.add(trimmedLink); // Add link to the Set
					let platformName = "other"; // Default name if no match is found

					// Check if the link contains a known platform's domain
					if (trimmedLink.includes("linkedin.com")) {
						platformName = platforms.linkedin;
					} else if (trimmedLink.includes("dribbble.com")) {
						platformName = platforms.dribbble;
					} else if (trimmedLink.includes("behance.com")) {
						platformName = platforms.behance;
					} else if (trimmedLink.includes("gitlab.com")) {
						platformName = platforms.gitlab;
					} else if (trimmedLink.includes("github.com")) {
						platformName = platforms.github;
					}

					// Create the object with link and name
					const data = {
						portfolioLink: trimmedLink,
						portfolioName: platformName,
					};

					// Add websiteName for unknown platforms
					if (platformName === "other") {
						data["websiteName"] = trimmedLink;
					}

					// Push to the result array
					portfolioObjects.push(data);
				}
			});

			// Return the array of objects
			return portfolioObjects;
		},

		setFormSubmitted() {
			let formDetails = {
				id: this.candidateInfo._id,
				formID: this.formID
			}
			trackFormSubmitted(formDetails)
		},

		async addPersonalDetails() {
			let form = new FormData();
			let payload = { ...this.newObject };
			if (this.newObject.dateOfBirth) {
				let value = this.newObject.dateOfBirth.slice(0, 10);
				if (this.isYYYMMDDFormat(value)) {
					value = this.convertDate(value);
					this.newObject.dateOfBirth = value;
				}
			}

			payload.portfolio =
				this.newObject.portfolio.length > 0
					? this.createPortfolioObjects(this.newObject.portfolio)
					: [];
			const [day, month, year] = this.newObject.dateOfBirth.split("-");
			payload.dateOfBirth = `${year}-${month}-${day}`;

			for (let key of Object.keys(payload)) {
				if (key == "portfolio") {
					form.append(key, JSON.stringify(payload[key]));
				} else {
					form.append(key, payload[key]);
				}
			}

			form.append(
				"id",
				this.candidateInfo._id || this.getPrimaryCandidateInfo._id
			);
			form.append(
				"email",
				this.candidateInfo.email || this.getPrimaryCandidateInfo.email
			);

			form.append("updateImage", this.getUpdateImage);
			if (this.isImageRemoved) {
				form.append("image", null);
			}

			const response = await postCandInfo(form);
			if (response.status == 200) {
				this.loading = false;
				if (this.candProgress?.profileCount == 1) {
					let profileData = {
						id: this.candidateInfo._id,
						primary: this.candidateInfo.primary
					}
					if (!this.candidateInfo.hasOwnProperty("parser")) {
						trackResumeCreated(profileData)
					}
					trackHomePageLoaded(profileData)
				}
				this.setFormSubmitted();
				this.originalData = {
					data: { ...this.newObject },
				};
				form.append("updateImage", this.getUpdateImage);
				this.$emit("close-modal");
				this.$emit("update-data", this.form);
				this.$nextTick(() => {
					this.$store.dispatch("userVUEX/fetchPostLoginData", true);
					this.successModal(
						"Successfully updated",
						"Profile have been updated"
					);
				});
				if (sessionStorage.getItem("fromOnboarding") === "true") {
					sessionStorage.removeItem("fromOnboarding");
					try {
						await updateCandidateOnboard({ action: "resumeParsed" });
						this.$store.commit("userVUEX/setIsFirstTimeUser", true);
					} catch (err) {
						console.error(
							"[commonForm] updateCandidateOnboard resumeParsed failed:",
							err
						);
					}
				}
				if (this.fromOnboarding) {
					const fromTraining =
						this.$route && this.$route.query && this.$route.query.fromTraining;
					const returnUrl =
						this.$route && this.$route.query && this.$route.query.returnUrl;
					this.$store.commit("candidateVUEX/setOnboardingActive", false);
					if (fromTraining && returnUrl) {
						window.location.href = decodeURIComponent(returnUrl);
						return;
					}
				}
				const primaryProfileDeomographics =
					store.getters["candidateVUEX/getPrimaryCandidateInfo"];
				console.log(store.state.candidateVUEX.resclinicRename, "ddddddddddddd");
				let prev = this.previousRoute;
				if (!prev) {
					let p = this.$parent;
					while (p && !prev) {
						if (p.previousRoute) {
							prev = p.previousRoute;
						}
						p = p.$parent;
					}
				}
				const isIgnoredRoute = (path) => {
					if (!path) return true;
					const p = path.toLowerCase();
					return p === "/" || p.includes("/login") || p.includes("/register");
				};
				if (
					!store.getters["candidateVUEX/getcandidateInfo"].primary &&
					!primaryProfileDeomographics.database_demographics &&
					!store.state.candidateVUEX.resclinicRename
				) {
					if (this.isLaptop) {
						console.log("Emit openModal from mixin");
						this.$emit("open-rename-modal");
					} else if (
						!localStorage.getItem("landing_onboarding_upload_flow_active")
					) {
						this.showresumerename = true;
					}
				}
				localStorage.removeItem("landing_onboarding_upload_flow_active");
				const fromWebsite = this.$route.query.fromWebsite;
				if (fromWebsite) {
					this.$router.push({
						name: "CandidateDashboard",
						query: fromWebsite ? { fromWebsite } : {},
					});
					return;
				} else if (!this.isLaptop && this.formID === "personalDetails") {
					let fromWebsiteVal = false;
					if (this.resumeClinic) fromWebsiteVal = true;
					this.$store.commit("userVUEX/setResumeClinic", false);
					let query = fromWebsiteVal ? { fromWebsite: true } : {};
					if (fromWebsiteVal) {
						this.$router.push({
							name: "CandidateDashboard",
							query,
						});
						return;
					} else {
						await this.$router.push(prev);
						return;
					}
				}
				// Complete upload/onboarding flow cleanup for mobile
				if (this.formID === "personalDetails") {
					const uploadKey = "landing_onboarding_upload_flow_active";
					let savedState = null;
					try {
						savedState = localStorage.getItem(uploadKey);
					} catch (e) {
						savedState = null;
					}

					if (savedState) {
						// Clear persisted flow state and global flag so parent won't reopen the modal
						try {
							localStorage.removeItem(uploadKey);
						} catch (e) {}
						try {
							this.$store.commit("candidateVUEX/setOnboardingActive", false);
						} catch (e) {}
						// try {
						// 	const { getCandidatePrimaryProfile } = await import("@/utils/apiFunctions");
						// 	const res = await getCandidatePrimaryProfile();
						// 	if (res?.status === 200 && res.data?.data) {
						// 		this.$store.commit("candidateVUEX/setPrimaryProfile", res.data.data);
						// 	}
						// } catch (e) {}

						// Match desktop redirect priority
						if (fromWebsite) {
							await this.$router.push({
								name: "CandidateDashboard",
								query: { fromWebsite },
							});
							return;
						}

						if (this.$route.query?.bycompany !== undefined) {
							await this.$router.push({
								name: "InterviewSkills",
								query: {
									bycompany: 1,
									company: this.$route.query.company || "",
									role: this.$route.query.role || "",
								},
							});
							return;
						}

						if (this.$route.query?.roadmapSkills) {
							await this.$router.push({
								name: "InterviewSkills",
								query: {
									byskill: true,
									skill: this.$route.query.roadmapSkills,
									index: 0,
									rec: 0,
									byCompany: 0,
									roadmapSkills: this.$route.query.roadmapSkills,
								},
							});
							return;
						}
						if (prev && !isIgnoredRoute(prev)) {
							await this.$router.push(prev);
						} else {
							await this.$router.push({ name: "CandidateDashboard" });
						}
						return;
					}
				}
			}
		},
		async addEducation() {
			try {
				let payload = {
					id: this.candidateInfo._id,
					email: this.candidateInfo.email,
					educationalInfo: [],
				};
				let object;
				object = this.newObject;
				delete object["customFields"];
				delete object["uniqueID"];
				delete object["courseDuration"];
				payload.educationalInfo.push(object);
				const response = await postCandEdu(payload);
				if (response.status == 200) {
					this.loading = false;
					this.setFormSubmitted();
					if (this.saveAndAddNew) {
						this.initializeData("add");
						this.$emit("data-added", this.saveAndAddNew);
						this.saveAndAddNew = false;
					} else {
						this.$emit("data-added", this.saveAndAddNew);
						this.$emit("close-modal");
					}
					this.$nextTick(() => {
						this.successModal("Success", "Education has been saved");
					});
				} else {
					this.loading = false;
					this.$nextTick(() => {
						this.errorModal("Something went wrong");
					});
				}
			} catch (error) {
				this.loading = false;
				this.errorModal("Something went wrong");
				throw new Error(error);
			}
		},
		async editEducation() {
			try {
				let payload = {
					id: this.candidateInfo._id,
					email: this.candidateInfo.email,
					educationalInfo: {},
				};
				let object;
				object = this.newObject;
				delete object["customFields"];
				delete object["uniqueID"];
				delete object["courseDuration"];
				payload.educationalInfo = object;
				const response = await putCandEdu(payload);
				if (response.status == 200) {
					this.setFormSubmitted();
					this.loading = false;
					if (!this.isLaptop) {
						this.$router.push({
							name: "MobileForm",
							query: {
								formID: this.formID,
							},
						});
					}
					this.$emit("data-added");
					this.$emit("close-modal");
					this.$nextTick(() => {
						this.successModal("Success", "Education has been updated");
					});
				}
			} catch (error) {
				throw new Error(error);
			}
		},
		async addExperience() {
			try {
				let payload = {
					id: this.candidateInfo._id,
					email: this.candidateInfo.email,
					experience: [],
				};
				let object;
				object = this.newObject;
				if (object.highlight && object.highlight.length > 0) {
					object.highlight = object.highlight.filter((value) => value !== "");
				}
				delete object["customFields"];
				delete object["uniqueID"];
				payload.experience.push(object);
				const response = await postCandExp(payload);
				if (response.status == 200) {
					this.setFormSubmitted();
					this.loading = false;
					if (this.saveAndAddNew) {
						this.initializeData("add");
						this.$emit("data-added", this.saveAndAddNew);
						this.saveAndAddNew = false;
					} else {
						this.$emit("data-added", this.saveAndAddNew);
						this.$emit("close-modal");
					}
					this.$nextTick(() => {
						this.successModal("Success", "Experience has been added");
					});
				}
			} catch (error) {
				throw new Error(error);
			}
		},
		async editExperience() {
			try {
				let payload = {
					id: this.candidateInfo._id,
					email: this.candidateInfo.email,
					experience: {},
				};
				let object;
				object = this.newObject;
				delete object["customFields"];
				delete object["uniqueID"];
				if (object.highlight && object.highlight.length > 0) {
					object.highlight = object.highlight.filter((value) => value !== "");
				}
				payload.experience = object;
				const response = await putCandExp(payload);
				if (response.status == 200) {
					this.setFormSubmitted();
					this.loading = false;
					if (this.saveAndAddNew) {
						this.initializeData("add");
						this.saveAndAddNew = false;
					} else {
						this.$emit("data-added");
						this.$emit("close-modal");
					}
					this.$nextTick(() => {
						this.successModal("Success", "Experience has been updated");
					});
				}
			} catch (error) {
				throw new Error(error);
			}
		},
		async addProject() {
			let payload = {
				id: this.candidateInfo._id,
				email: this.candidateInfo.email,
				projects: [],
			};
			let object;
			object = this.newObject;
			if (object.responsibility && object.responsibility.length > 0) {
				object.responsibility = object.responsibility.filter(
					(value) => value !== ""
				);
			}
			delete object["customFields"];
			delete object["uniqueID"];
			delete object["association_obj"];
			delete object["description"];
			payload.projects.push(object);

			const response = await postProjectsInfo(payload);
			if (response.status == 200) {
				this.setFormSubmitted();
				this.loading = false;
				if (this.saveAndAddNew) {
					this.initializeData("add");
					this.$emit("data-added", this.saveAndAddNew);
					this.saveAndAddNew = false;
				} else {
					this.$emit("data-added", this.saveAndAddNew);
					this.$emit("close-modal");
				}
				this.$nextTick(() => {
					this.successModal("Success", "Project has been added");
				});
			}
		},
		async editProject() {
			let payload = {
				id: this.candidateInfo._id,
				email: this.candidateInfo.email,
				projects: {},
			};
			let object;
			object = this.newObject;
			if (object.responsibility && object.responsibility.length > 0) {
				object.responsibility = object.responsibility.filter(
					(value) => value !== ""
				);
			}
			delete object["customFields"];
			delete object["uniqueID"];
			delete object["association_obj"];
			delete object["description"];
			payload.projects = object;

			const response = await putProjectEdit(payload);
			if (response.status == 200) {
				this.setFormSubmitted();
				this.loading = false;
				if (this.saveAndAddNew) {
					this.initializeData("add");
					this.saveAndAddNew = false;
				} else {
					this.$emit("data-added");
					this.$emit("close-modal");
				}
				this.$nextTick(() => {
					this.successModal("Success", "Project has been updated");
				});
			}
		},
		async addAchievement() {
			this.newObject.isExpire = false;
			if (this.newObject.uploadFile && this.uploadbtnClick) {
				let form = new FormData();
				form.append("id", this.candidateInfo._id);
				form.append("email", this.candidateInfo.email);
				form.append("file", this.newObject["uploadFile"]);
				if (this.newObject.achieveType == "certificate") {
					form.append("bucketKey", "certifications");
				} else {
					form.append("bucketKey", "awards");
				}
				const response = await postCandAchieveFileUpload(form);
				if (response.status == 200) {
					var uploadFileLink = response.data.data.key;
				}
			}
			if (this.newObject.achieveType == "certificate") {
				let payload = {
					id: this.candidateInfo._id,
					email: this.candidateInfo.email,
					achievement: [],
				};
				let achievementData = { ...this.newObject };
				achievementData.uploadFile = uploadFileLink ? uploadFileLink : null;
				delete achievementData["customFields"];
				delete achievementData["expirationDate"];
				delete achievementData["uniqueID"];
				delete achievementData["uploadFileLink"];
				delete achievementData["fileRemoved"];

				payload.achievement.push(achievementData);
				const res = await postCandAchieve(payload);
				if (res.status == 200) {
					this.setFormSubmitted();
					this.$nextTick(() => {
						this.successModal("Success", "Achievement has been added");
					});
					this.loading = false;
					if (this.saveAndAddNew) {
						this.initializeData("add");
						this.$emit("data-added", this.saveAndAddNew);
						this.saveAndAddNew = false;
					} else {
						this.$emit("data-added", this.saveAndAddNew);
						this.$emit("close-modal");
					}
				}
			}
			if (this.newObject.achieveType == "award") {
				let payload = {
					id: this.candidateInfo._id,
					email: this.candidateInfo.email,
					awards: [],
				};
				let awardData = { ...this.newObject };
				awardData.uploadFile = uploadFileLink ? uploadFileLink : null;
				delete awardData["customFields"];
				delete awardData["certificateID"];
				delete awardData["expirationDate"];
				delete awardData["uniqueID"];
				delete awardData["uploadFileLink"];
				delete awardData["usedSkills"];
				delete awardData["fileRemoved"];

				payload.awards.push(awardData);
				const response = await postCandAward(payload);
				if (response.status === 200) {
					this.$nextTick(() => {
						this.successModal("Success", "Achievement has been added");
					});
					this.loading = false;
					if (this.saveAndAddNew) {
						this.initializeData("add");
						this.$emit("data-added", this.saveAndAddNew);
						this.saveAndAddNew = false;
					} else {
						this.$emit("data-added", this.saveAndAddNew);
						this.$emit("close-modal");
					}
				}
			}
			if (this.newObject.achieveType == "event") {
				let payload = {
					id: this.candidateInfo._id,
					email: this.candidateInfo.email,
					events: [],
				};
				let eventData = { ...this.newObject };
				delete eventData["customFields"];
				delete eventData["certificateID"];
				delete eventData["expirationDate"];
				delete eventData["link"];
				delete eventData["uniqueID"];
				delete eventData["uploadFile"];
				delete eventData["uploadFileLink"];
				delete eventData["usedSkills"];

				payload.events.push(eventData);
				const response = await postCandEvent(payload);
				if (response.status === 200) {
					this.$nextTick(() => {
						this.successModal("Success", "Achievement has been added");
					});
					this.loading = false;
					if (this.saveAndAddNew) {
						this.initializeData("add");
						this.$emit("data-added", this.saveAndAddNew);
						this.saveAndAddNew = false;
					} else {
						this.$emit("data-added", this.saveAndAddNew);
						this.$emit("close-modal");
					}
				}
			}
		},
		async editAchievement() {
			this.newObject.isExpire = false;
			if (this.newObject.uploadFile && this.uploadbtnClick) {
				let form = new FormData();
				form.append("id", this.candidateInfo._id);
				form.append("email", this.candidateInfo.email);
				form.append("file", this.newObject["uploadFile"]);
				if (this.newObject.achieveType == "certificate") {
					form.append("bucketKey", "certifications");
				} else {
					form.append("bucketKey", "awards");
				}
				const response = await postCandAchieveFileUpload(form);
				if (response.status == 200) {
					var uploadFileLink = response.data.data.key;
				}
			}
			if (this.newObject.achieveType == "certificate") {
				let payload = {
					id: this.candidateInfo._id,
					email: this.candidateInfo.email,
					achievement: {},
				};
				let achievementData = { ...this.newObject };

				achievementData.uploadFile = uploadFileLink
					? uploadFileLink
					: this.newObject.uploadFileLink;
				delete achievementData["customFields"];
				delete achievementData["uniqueID"];
				if (
					this.newObject.fileRemoved ||
					Array.isArray(this.newObject.uploadFile)
				) {
					achievementData.uploadFile = null;
					delete achievementData.uploadFileLink;
					delete achievementData.fileRemoved;
				}
				payload.achievement = achievementData;
				const res = await putCandAchieve(payload);
				if (res.status == 200) {
					this.setFormSubmitted();
					this.$nextTick(() => {
						this.successModal("Success", "Achievement has been added");
					});
					this.loading = false;
					if (this.saveAndAddNew) {
						this.initializeData("add");
						this.saveAndAddNew = false;
					} else {
						this.$emit("data-added");
						this.$emit("close-modal");
					}
				}
			}
			if (this.newObject.achieveType == "award") {
				let payload = {
					id: this.candidateInfo._id,
					email: this.candidateInfo.email,
					awards: {},
				};
				let awardData = { ...this.newObject };
				awardData.uploadFile = uploadFileLink
					? uploadFileLink
					: this.newObject.uploadFile;
				delete awardData["customFields"];
				delete awardData["uploadFileLink"];
				delete awardData["uniqueID"];
				delete awardData["certificateID"];
				delete awardData["expirationDate"];
				delete awardData["usedSkills"];
				delete awardData["fileRemoved"];
				if (
					this.newObject.fileRemoved ||
					Array.isArray(this.newObject.uploadFile)
				) {
					awardData.uploadFile = null;
					delete awardData.uploadFileLink;
					delete awardData.fileRemoved;
				}
				payload.awards = awardData;
				const response = await putCandAward(payload);
				if (response.status === 200) {
					awardData;
					this.$nextTick(() => {
						this.successModal("Success", "Achievement has been added");
					});
					this.loading = false;
					if (this.saveAndAddNew) {
						this.initializeData("add");
						this.$emit("data-added", this.saveAndAddNew);
						this.saveAndAddNew = false;
					} else {
						this.$emit("data-added", this.saveAndAddNew);
						this.$emit("close-modal");
					}
				}
			}
			if (this.newObject.achieveType == "event") {
				let payload = {
					id: this.candidateInfo._id,
					email: this.candidateInfo.email,
					events: {},
				};
				let eventData = { ...this.newObject };
				delete eventData["customFields"];
				delete eventData["uniqueID"];

				payload.events = eventData;
				const response = await putCandEvent(payload);
				if (response.status === 200) {
					this.$nextTick(() => {
						this.successModal("Success", "Achievement has been added");
					});
					this.loading = false;
					if (this.saveAndAddNew) {
						this.initializeData("add");
						this.$emit("data-added", this.saveAndAddNew);
						this.saveAndAddNew = false;
					} else {
						this.$emit("data-added", this.saveAndAddNew);
						this.$emit("close-modal");
					}
				}
			}
		},
	},
};
